import { css } from '@emotion/react';

export const sortableItemStyles = css({
  touchAction: 'none !important',
  cursor: 'grab !important',
  position: 'relative',
  '&[data-dragging="true"]': {
    cursor: 'grabbing !important',
    opacity: 0.5,
    zIndex: 1,
  },
});
